import React, { useState, useEffect } from 'react';
import { bolusnotesApi } from '../services/api';

interface AvatarProps {
  profileImageUrl?: string | null;
  size?: number;
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({ profileImageUrl, size = 60, className = '' }) => {
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (profileImageUrl) {
      let isMounted = true;
      setLoading(true);
      
      bolusnotesApi.files.presign(profileImageUrl)
        .then((res: any) => {
          if (isMounted && res.url) {
            setAvatarUrl(res.url);
          }
        })
        .catch(err => console.error("Could not presign avatar", err))
        .finally(() => {
          if (isMounted) setLoading(false);
        });

      return () => { isMounted = false; };
    } else {
      setAvatarUrl(null);
    }
  }, [profileImageUrl]);

  const defaultAvatar = (
    <div 
      className={`default-avatar ${className}`}
      style={{ 
        width: `${size}px`, 
        height: `${size}px`, 
        borderRadius: '50%', 
        backgroundColor: '#e9ecef', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        fontSize: `${size * 0.4}px` 
      }}
    >
      👤
    </div>
  );

  if (loading && profileImageUrl) {
    return (
      <div 
        className={`avatar-loading ${className}`}
        style={{ 
          width: `${size}px`, 
          height: `${size}px`, 
          borderRadius: '50%', 
          backgroundColor: '#f8f9fa',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        ...
      </div>
    );
  }

  return avatarUrl ? (
    <img 
      src={avatarUrl} 
      alt="Avatar" 
      className={`profile-avatar-img ${className}`}
      style={{ 
        width: `${size}px`, 
        height: `${size}px`, 
        borderRadius: '50%', 
        objectFit: 'cover' 
      }} 
      onError={() => setAvatarUrl(null)}
    />
  ) : defaultAvatar;
};

export default Avatar;
